import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { intercompanyService, type SettlePayload } from '../services/intercompany.service';

const KEY = 'intercompany-balance';
const SETTLEMENTS_KEY = 'intercompany-settlements';

export function useIntercompanyBalance(year: number, month: number, enabled = true) {
  return useQuery({
    queryKey: [KEY, year, month],
    queryFn: () => intercompanyService.getBalance(year, month),
    enabled,
  });
}

export function useIntercompanySettlements(year: number, month: number, enabled = true) {
  return useQuery({
    queryKey: [SETTLEMENTS_KEY, year, month],
    queryFn: () => intercompanyService.listSettlements(year, month),
    enabled,
  });
}

/**
 * Invalida saldo, quitações e fechamento. Quitar e estornar mexem nos três: os
 * rateios trocam de status, a lista de quitações muda e as pernas de caixa
 * entram ou saem do mês.
 */
function useInvalidateAfterSettle() {
  const qc = useQueryClient();
  return () => {
    qc.invalidateQueries({ queryKey: [KEY] });
    qc.invalidateQueries({ queryKey: [SETTLEMENTS_KEY] });
    qc.invalidateQueries({ queryKey: ['financial-ops', 'closings'] });
  };
}

export function useSettleIntercompany() {
  const invalidate = useInvalidateAfterSettle();
  return useMutation({
    mutationFn: (payload: SettlePayload) => intercompanyService.settle(payload),
    onSuccess: invalidate,
  });
}

export function useReverseSettlement() {
  const invalidate = useInvalidateAfterSettle();
  return useMutation({
    mutationFn: (settlementId: string) => intercompanyService.reverse(settlementId),
    onSuccess: invalidate,
  });
}
